import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const SaveAdmissionsFormDraftMutation = graphql.persisted(
  "SaveAdmissionsFormDraft",
  graphql(`
    mutation SaveAdmissionsFormDraft($token: String!, $formData: JSON!) {
      saveAdmissionsFormDraft(input: { token: $token, formData: $formData }) {
        familyEnrollment { id }
        userErrors { message path }
      }
    }
  `)
);

export { SaveAdmissionsFormDraftMutation };

export function useSaveAdmissionsFormDraft() {
  return useMutation(SaveAdmissionsFormDraftMutation);
}
